<template>
  <v-container pa-0 fluid @touchstart="touchEnable">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card tile class="pt-0 pb-2 mt-0 overflow-x-hidden card-shadow">
          <div class="top-guide">
            <div class="top-guide-text">
              <span v-if="userName">{{ userName }}님,<br>어떤 유학을 원하세요?</span>
              <span v-else>지금부터 만들어가요<br>나만의 유학 스토리</span>
            </div>
          </div>

          <!--            <div class="big-switch">-->
          <!--              <div class="big-switch-label">-->
          <!--                <v-btn flat :ripple="false" @click="switchDelta = 0" :color="switchDelta ? '#9497b2' : '#4a4a4a'">둘러보기</v-btn>-->
          <!--                <v-btn flat :ripple="false" @click="switchDelta = 105" :color="switchDelta ? '#4a4a4a' : '#9497b2'">시작하기</v-btn>-->
          <!--              </div>-->
          <!--              <div class="big-switch-button" :style="{ transform: `translateX(${switchDelta}px)`}"></div>-->
          <!--            </div>-->

          <!--            <div v-show="switchDelta === 0" class="tour-swiper-container swiper-container mt-5" style="height: 136px;">-->
          <!--              <div class="tour-swiper-wrapper swiper-wrapper">-->
          <!--                <div class="tour-swiper-slide swiper-slide" v-for="(item, index) of tour" :key="item.idx" style="width: 136px;">-->
          <!--                  <v-img :src="require(`@/assets/img/tour-flag-${item.idx}.png`)" width="136px" class="ma-0"-->
          <!--                         style="border-radius: 50%;"-->
          <!--                         :gradient="index > 3 ? 'to top, rgba(30,30,30,.5), rgba(30,30,30,.5)' : undefined"-->
          <!--                         @click="index > 3 ? undefined : $router.push({ name: 'TourHome', params: { idx: item.idx } })">-->
          <!--                    <v-layout column align-center justify-center fill-height style="font-size: 18px; font-weight: 700; color: white; letter-spacing: -0.75px;">-->
          <!--                      <span :style="{ opacity: index > 3 ? '0.5' : '1' }">{{ item.name }}</span>-->
          <!--                      <span v-if="index > 3">준비중</span>-->
          <!--                    </v-layout>-->
          <!--                  </v-img>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <div v-show="switchDelta > 0" class="recommend-swiper-container swiper-container mt-5" style="height: 136px;">-->
          <!--              <div class="recommend-swiper-wrapper swiper-wrapper">-->
          <!--                <div class="recommend-swiper-slide swiper-slide" v-for="item of recommend" :key="item.idx" style="width: 241px; height: 136px;">-->
          <!--                  <v-img :src="`${$storage}/store/${item.thumbnail}`" height="136px" :aspect-ratio="16/9"-->
          <!--                         class="ma-0 blue-grey lighten-5" style="border-radius: 5px;"-->
          <!--                         @click="$router.push({ name: 'ReadProduct', params: { idx: item.idx } })">-->
          <!--                  </v-img>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <v-img :src="isMobile ? require('@/assets/img/unlimited-banner.png') : require('@/assets/img/unlimited-banner-desktop.png')"
                 style="align-items: center;"
                 @click="onClickEventBanner">
          </v-img>

          <v-card-title primary-title class="pb-0 pt-3 mt-3 text-xs-left title-style">
            <h1 class="display-4">최저가 보장 <span style="font-weight: 400;">어학연수</span></h1>
          </v-card-title>

          <v-card-title class="pt-0 pb-3">
            <v-layout row align-end>
              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">
                가격은 최저가로 ⬇️ 혜택은 더 빵빵하게! 🎁
              </span>
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-title>

          <div class="hot-language-swiper-container swiper-container" style="padding: 0 16px;">
            <div class="hot-language-swiper-wrapper swiper-wrapper">
              <div class="hot-language-swiper-slide swiper-slide"
                   v-for="(product, index) of languageStudyStore" :key="index">
                <ProductCard :idx="product.idx"
                             :title="product.title"
                             :subtitle="product.subtitle"
                             :publishedAt="product.published_at"
                             :status="product.status"
                             :thumbnail="product.thumbnail"
                             :bookmarks="product.bookmarks"
                             :subtitle_color="product.subtitle_color"
                             @bookmark="bookmarkProduct(product.idx)" />
              </div>
            </div>
          </div>

          <v-card-title primary-title class="pb-0 pt-0 mt-3 text-xs-left title-style">
            <h1 class="display-4"><span style="font-weight: 400;">인기</span> TOP5 클래스</h1>
          </v-card-title>

          <v-card-title class="pt-0 pb-3">
            <v-layout row align-end>
              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">
                유학생이 직접 알려주는 유학준비, 혼자서도 할 수 있어요 💪
              </span>
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-title>

          <div class="hot-stories-swiper-container swiper-container" style="padding: 0 16px 16px;">
            <div class="hot-stories-swiper-wrapper swiper-wrapper">
              <div class="hot-stories-swiper-slide swiper-slide"
                   v-for="(product, index) of hotStories" :key="index">
                <ProductCard :idx="product.idx"
                             :title="product.title"
                             :subtitle="product.subtitle"
                             :publishedAt="product.published_at"
                             :status="product.status"
                             :thumbnail="product.thumbnail"
                             :bookmarks="product.bookmarks"
                             :subtitle_color="product.subtitle_color"
                             @bookmark="bookmarkProduct(product.idx)" />
              </div>
            </div>
          </div>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card tile class="pt-4 pb-2 mt-2 overflow-x-hidden card-shadow"
                v-for="(section, index) of curations" :key="index">
          <v-card-title primary-title class="pb-0 pt-1 text-xs-left title-style">
            <h1 class="display-4">{{ section.subjects.title }}</h1>
          </v-card-title>

          <v-card-title class="py-0" v-if="section.subjects.introduce">
            <v-layout row align-end>
              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">{{ section.subjects.introduce }}</span>
              <v-spacer></v-spacer>
              <v-btn v-if="section.contents.length > 1"
                     :to="{ name: 'TourHome', params: { idx: section.subjects.idx } }"
                     class="custom-color-brown-grey pr-0 ma-0"
                     style="min-width: unset;"
                     exact
                     flat
                     small>
                <span class="caption">더보기</span>
                <v-icon color="#4a4a4a" size="16px">$vuetify.icons.arrowRight</v-icon>
              </v-btn>
            </v-layout>
          </v-card-title>

          <v-card-text class="ma-0 pt-4 pl-0 pr-0 pb-0">
            <div :id="`slide-${index}`"
                 class="swiper-container"
                 :class="section.contents.length === 1 ? '' : 'post-swiper-container'">
              <div class="post-swiper-wrapper swiper-wrapper">
                <div class="post-swiper-slide swiper-slide"
                     :class="section.contents.length === 1 ? 'px-3' : ''"
                     style="box-sizing: border-box;"
                     :style="{ width: section.contents.length === 1 ? '100%' : '300px' }"
                     v-for="post of section.contents" :key="post.idx">
                  <FeedCard v-if="post.type === 'feed'"
                            :channelIdx="post.channels.idx"
                            :width="section.contents.length > 1 ? '300px' : ''"
                            :idx="post.idx"
                            :contents="post.contents"
                            :hashtag="post.hashtag"
                            :imageList="post.image_list"
                            :userName="post.user.name"
                            :userProfileImage="post.user.profile_image"
                            :createdAt="post.created_at"
                            :likes="post.likes"
                            :likeCnt="post.like_cnt"
                            :commentCnt="post.comment_cnt"
                            @like="like(post.idx, index)" />
                  <ContentCard v-else
                               :width="section.contents.length > 1 ? '300px' : ''"
                               :idx="post.idx"
                               :type="post.type"
                               :video_id="post.video_id"
                               :thumbnail="post.thumbnail"
                               :title="post.title"
                               :subtitle="post.subtitle"
                               :subtitle_color="post.subtitle_color" />
                </div>
              </div>
            </div>
          </v-card-text>

<!--          <v-slide-x-transition leave-absolute hide-on-leave v-if="section.contents.length > 1">-->
<!--            <v-card-actions :key="currentSlides[index]" class="pa-0">-->
<!--              <v-list class="pa-0 grow">-->
<!--                <v-list-tile avatar class="px-2" :to="{ name: 'Channel', params: { idx: currentChannels[index].idx } }">-->
<!--                  <v-list-tile-avatar size="24px" style="min-width: unset;" class="pr-2">-->
<!--                    <v-img :src="currentChannels[index].thumbnail ? `${$storage}/channel/${currentChannels[index].thumbnail}` : profileDefault"></v-img>-->
<!--                  </v-list-tile-avatar>-->

<!--                  <v-list-tile-content>-->
<!--                    <v-list-tile-title>-->
<!--                      <h3 class="display-2">{{ currentChannels[index].title }}</h3>-->
<!--                    </v-list-tile-title>-->
<!--                  </v-list-tile-content>-->
<!--                </v-list-tile>-->
<!--              </v-list>-->
<!--            </v-card-actions>-->
<!--          </v-slide-x-transition>-->
        </v-card>
      </v-flex>

      <!-- 상품 리스트. 16개까지 노출 -->
      <v-flex xs12>
        <v-card tile class="pb-3 mt-2 overflow-x-hidden card-shadow">
          <v-card-title primary-title class="pb-0 text-xs-left title-style">
            <h1 class="display-4">지금 시작하기</h1>
          </v-card-title>

          <v-card-title class="pt-0 pb-3">
            <v-layout row align-end>
              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">
                유스와 함께 준비하세요 ✏️
              </span>
              <v-spacer></v-spacer>
              <v-btn flat small class="custom-color-brown-grey pr-0 ma-0" style="min-width: unset;"
                     @click="$router.push({ name: 'Store' })">
                <span class="caption">더보기</span>
                <v-icon color="#4a4a4a" size="16px">$vuetify.icons.arrowRight</v-icon>
              </v-btn>
            </v-layout>
          </v-card-title>

          <v-container fluid grid-list-md class="py-0">
            <v-layout row wrap>
              <v-flex xs6 v-for="(product, index) of store" :key="index">
                <ProductCard :idx="product.idx"
                             :title="product.title"
                             :subtitle="product.subtitle"
                             :publishedAt="product.published_at"
                             :status="product.status"
                             :thumbnail="product.thumbnail"
                             :bookmarks="product.bookmarks"
                             :subtitle_color="product.subtitle_color"
                             @bookmark="bookmarkProduct(product.idx)" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

<!--      &lt;!&ndash; 큐레이션 영역 &ndash;&gt;-->
<!--      <v-flex xs12>-->
<!--        <v-card tile class="pt-4 pb-2 mt-2 overflow-x-hidden card-shadow" v-for="(section, index) of curations" :key="index">-->
<!--          <v-card-title primary-title class="pb-0 pt-1 text-xs-left title-style">-->
<!--            <h1 class="display-4">{{ section.subjects.title }}</h1>-->
<!--          </v-card-title>-->

<!--          <v-card-title class="py-0" v-if="section.subjects.introduce">-->
<!--            <v-layout row align-end>-->
<!--              <span class="body-2 custom-body text-xs-left" style="margin-bottom: 3px;">{{ section.subjects.introduce }}</span>-->
<!--&lt;!&ndash;              <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;              <v-btn v-if="section.contents.length > 1" flat small class="custom-color-brown-grey pr-0 ma-0" style="min-width: unset;"&ndash;&gt;-->
<!--&lt;!&ndash;                     :to="{ name: 'Topic', params: { sectionIdx: section.idx }, query: { subjectIdx: section.subjects.idx, sectionTitle: section.subjects.title } }">&ndash;&gt;-->
<!--&lt;!&ndash;                <span class="caption">더보기</span>&ndash;&gt;-->
<!--&lt;!&ndash;                <v-icon color="#4a4a4a" size="16px">$vuetify.icons.arrowRight</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;              </v-btn>&ndash;&gt;-->
<!--            </v-layout>-->
<!--          </v-card-title>-->

<!--          <v-card-text class="ma-0 pt-4 pl-0 pr-0 pb-0">-->

<!--            <div :id="`slide-${index}`"-->
<!--                 class="swiper-container"-->
<!--                 :class="section.contents.length === 1 ? '' : 'post-swiper-container'">-->
<!--              <div class="post-swiper-wrapper swiper-wrapper">-->
<!--                <div class="post-swiper-slide swiper-slide"-->
<!--                     :class="section.contents.length === 1 ? 'px-3' : ''"-->
<!--                     style="box-sizing: border-box;"-->
<!--                     :style="{ width: section.contents.length === 1 ? '100%' : '300px' }"-->
<!--                     v-for="post of section.contents" :key="post.idx">-->
<!--                  <FeedCard v-if="post.type === 'feed'"-->
<!--                            :channelIdx="post.channels.idx"-->
<!--                            :width="section.contents.length > 1 ? '300px' : ''"-->
<!--                            :idx="post.idx"-->
<!--                            :contents="post.contents"-->
<!--                            :hashtag="post.hashtag"-->
<!--                            :imageList="post.image_list"-->
<!--                            :userName="post.user.name"-->
<!--                            :userProfileImage="post.user.profile_image"-->
<!--                            :createdAt="post.created_at"-->
<!--                            :likes="post.likes"-->
<!--                            :likeCnt="post.like_cnt"-->
<!--                            :commentCnt="post.comment_cnt"-->
<!--                            @like="like(post.idx, index)" />-->
<!--                  <ContentCard v-else-->
<!--                               :width="section.contents.length > 1 ? '300px' : ''"-->
<!--                               :idx="post.idx"-->
<!--                               :type="post.type"-->
<!--                               :video_id="post.video_id"-->
<!--                               :thumbnail="post.thumbnail"-->
<!--                               :title="post.title"-->
<!--                               :subtitle="post.subtitle"-->
<!--                               :subtitle_color="post.subtitle_color" />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </v-card-text>-->

<!--&lt;!&ndash;          <v-slide-x-transition leave-absolute hide-on-leave v-if="section.contents.length > 1">&ndash;&gt;-->
<!--&lt;!&ndash;            <v-card-actions :key="currentSlides[index]" class="pa-0">&ndash;&gt;-->
<!--&lt;!&ndash;              <v-list class="pa-0 grow">&ndash;&gt;-->
<!--&lt;!&ndash;                <v-list-tile avatar class="px-2" :to="{ name: 'Channel', params: { idx: currentChannels[index].idx } }">&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-list-tile-avatar size="24px" style="min-width: unset;" class="pr-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-img :src="currentChannels[index].thumbnail ? `${$storage}/channel/${currentChannels[index].thumbnail}` : profileDefault"></v-img>&ndash;&gt;-->
<!--&lt;!&ndash;                  </v-list-tile-avatar>&ndash;&gt;-->

<!--&lt;!&ndash;                  <v-list-tile-content>&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-list-tile-title>&ndash;&gt;-->
<!--&lt;!&ndash;                      <h3 class="display-2">{{ currentChannels[index].title }}</h3>&ndash;&gt;-->
<!--&lt;!&ndash;                    </v-list-tile-title>&ndash;&gt;-->
<!--&lt;!&ndash;                  </v-list-tile-content>&ndash;&gt;-->
<!--&lt;!&ndash;                </v-list-tile>&ndash;&gt;-->
<!--&lt;!&ndash;              </v-list>&ndash;&gt;-->
<!--&lt;!&ndash;            </v-card-actions>&ndash;&gt;-->
<!--&lt;!&ndash;          </v-slide-x-transition>&ndash;&gt;-->
<!--        </v-card>-->
<!--      </v-flex>-->

    </v-layout>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';

  import FeedCard from '@/components/FeedCard';
  import ContentCard from '@/components/ContentCard';
  import ProductCard from "@/components/ProductCard";
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'TabHome',
    components: { ProductCard, FeedCard, ContentCard },
    props: [ 'isActive' ],
    computed: {
      ...mapGetters('user', { userIdx: 'idx', userName: 'name' }),
      ...mapGetters('home', [ 'tour', 'recommend', 'hotStories', 'languageStudyStore', 'store', 'curations' ]),
      currentChannels () {
        let arr = [];
        this.curations.forEach((section, index) => {
          if (section.contents.length > 1) arr[index] = section.contents[this.currentSlides[index]].channels;
        });
        return arr;
      },
      profileDefault () {
        return require('@/assets/img/profile-default.png');
      },
			isMobile () {
      	return navigator.userAgent.includes('Mobi');
			}
    },
    data () {
      return {
        second: parseInt(new Date().getTime() / 1000),
        page: 1,
        communityPage: 1,
        bottom: true,
        switchDelta: 0,
        // currentSlides: [0, 0, 0, 0, 0],
        curationSwipers: [],
        // carouselSwiper: null,
        tourSwiper: null,
        recommendSwiper: null,
        hotStoriesSwiper: null,
        hotLanguageSwiper: null,
      };
    },
    created () {
      this.swiperInit();
      this.selectStore({ second: this.second, page: 1 });
      if (this.curations.length) {
        this.currentSlides = Array(this.curations.length).fill(0);
      }
      this.selectCurations({ second: this.second }).then(() => {
        // this.curationSwiperInit();
        this.currentSlides = Array(this.curations.length).fill(0);
        this.$nextTick(() => {
          for (let item of this.curations) {
            if (item.contents.length > 1) {
              this.curationSwiperInit();
              break;
            }
          }
        });
      });
      // window.addEventListener('scroll', this.bottomVisible);
    },
    mounted () {
      // if (this.carouselSwiper) this.carouselSwiper.update();
      if (this.hotStoriesSwiper) this.hotStoriesSwiper.update();
      if (this.hotLanguageSwiper) this.hotLanguageSwiper.update();
    },
    updated () {
      this.curationSwiperInit();
      // if (this.carouselSwiper) this.carouselSwiper.update();
      if (this.hotStoriesSwiper) this.hotStoriesSwiper.update();
      if (this.hotLanguageSwiper) this.hotLanguageSwiper.update();
    },
    beforeDestroy () {
      // if (this.carouselSwiper) this.carouselSwiper.destroy();
      if (this.hotStoriesSwiper) this.hotStoriesSwiper.destroy();
      if (this.hotLanguageSwiper) this.hotLanguageSwiper.destroy();
      if (this.curationSwipers.length) this.curationSwipers.forEach(swiper => {
        swiper.destroy();
      });
    },
    destroyed () {
      // window.removeEventListener('scroll', this.bottomVisible);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (this.isActive && bottom && !oldBottom) {
          this.currentSlides.push(0, 0, 0, 0, 0);
          this.selectCurations({ second: this.second, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
      switchDelta (delta) {
        // console.log(this.tourSwiper, this.recommendSwiper);
        if (delta > 0 && !this.recommendSwiper) {
          this.$nextTick(() => {
            let root = this;
            this.recommendSwiper = new Swiper('.recommend-swiper-container', {
              direction: 'horizontal',
              slidesPerView: 'auto',
              spaceBetween: 16,
              slidesOffsetBefore: 36,
              slidesOffsetAfter: 36,
              on: {
                touchMove() {
                  root.touchCancel();
                },
              }
            });
          });
        }
      }
    },
    methods: {
      ...mapMutations('home', { mutationToggleLike: 'TOGGLE_LIKE', mutationToggleBookmark: 'TOGGLE_BOOKMARK', mutationToggleStoreBookmark: 'TOGGLE_STORE_BOOKMARK' }),
      ...mapActions('home', [ 'selectHome', 'selectStore', 'selectCurations' ]),
      ...mapActions('post', [ 'toggleLike', 'toggleBookmark' ]),
      ...mapActions('product', { toggleStoreBookmark: 'toggleBookmark', enrollCoupon: 'enrollCoupon' }),
      swiperInit () {
        this.selectHome(this.second).then(() => {
          let root = this;
          this.$nextTick(() => {
            // this.carouselSwiper = new Swiper('.carousel-swiper-container', {
            //   direction: 'horizontal',
            //   autoplay: {
            //     delay: 5000,
            //   },
            //   width: window.innerWidth,
            //   height: window.innerWidth,
            //   pagination: {
            //     el: '.carousel-swiper-pagination',
            //     clickable: true,
            //     renderBullet: function (index, className) {
            //       return `<div class="${className}" style="width: 40px; height: 40px; background-size: cover; background-image: url('${root.carousel[index].thumbnail_url}')"></div>`;
            //     },
            //   },
            //   on: {
            //     // init () {
            //     //   console.log('carouselSwiper init');
            //     // },
            //     touchMove() {
            //       root.touchCancel();
            //     },
            //   }
            // });

            this.tourSwiper = new Swiper('.tour-swiper-container', {
              direction: 'horizontal',
              slidesPerView: 'auto',
              spaceBetween: 16,
              slidesOffsetBefore: 36,
              slidesOffsetAfter: 36,
              on: {
                touchMove() {
                  root.touchCancel();
                },
              }
            });

            this.hotStoriesSwiper = new Swiper('.hot-stories-swiper-container', {
              direction: 'horizontal',
              slidesPerView: 2,
              spaceBetween: 10,
              on: {
                // init () {
                //   console.log('hotStoriesSwiper init');
                // },
                touchMove() {
                  root.touchCancel();
                },
              }
            });

            this.hotLanguageSwiper = new Swiper('.hot-language-swiper-container', {
              direction: 'horizontal',
              slidesPerView: 2,
              spaceBetween: 10,
              on: {
                // init () {
                //   console.log('hotStoriesSwiper init');
                // },
                touchMove() {
                  root.touchCancel();
                },
              }
            });
          });
        });
      },
      bookmarkProduct (idx) {
        this.toggleStoreBookmark(idx).then(response => {
          this.mutationToggleStoreBookmark({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      curationSwiperInit () {
        let root = this;
        let containers = document.querySelector('.post-swiper-container');
        if (containers) {
          let swiper = new Swiper('.post-swiper-container', {
            direction: 'horizontal',
            slidesPerView: 'auto',
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            // width: 300,
            spaceBetween: 8,
            on: {
              init() {
                this.el.classList.remove('post-swiper-container');
              },
              touchMove() {
                root.touchCancel();
              },
              // transitionStart() {
              //   // console.log(this.activeIndex, this.isEnd);
              //   const sectionIndex = this.el.getAttribute('id').split('-')[1];
              //   root.$set(root.currentSlides, sectionIndex, this.isEnd ? this.activeIndex + 1 : this.activeIndex);
              // }
            }
          });
          if (typeof swiper.length !== 'undefined') this.curationSwipers.push(...swiper);
          else this.curationSwipers.push(swiper);
        }
      },
      touchCancel () {
        this.$eventBus.$emit('touchCancel', true);
      },
      touchEnable () {
        this.$eventBus.$emit('touchCancel', false);
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 300;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
      like (idx, subjectIdx) {
        this.toggleLike(idx).then(response => {
          this.mutationToggleLike({ idx, flag: response.data, location: 'today', subjectIdx });
        }).catch(err => {
          console.error(err);
        });
      },
      carouselLink (storeIdx) {
        if (storeIdx) this.$router.push({ name: 'ReadProduct', params: { idx: storeIdx } });
        else this.$router.replace({ name: 'Store' });
      },
      onClickEventBanner () {
        this.$router.push({ name: 'ReadProduct', params: { idx: '54' } });
      }
    },
  }
</script>

<style lang="scss" scoped>
  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }
  .title-style {
    word-break: keep-all;
    word-wrap: break-word;
  }

  .custom-body {
    color: #707070;
    font-size: 14px;
    letter-spacing: -0.35px;
  }

  .top-guide {
    //height: 448px;
    background-image: linear-gradient(to top, #ffffff, #f4f3f7);
    &-text {
      //width: 288px;
      height: 76px;
      text-align: left;

      box-sizing: content-box;
      //padding-top: 56px;
      padding: 48px 16px 18px;
      //margin-left: auto;
      //margin-right: auto;
      //margin-bottom: 18px;
      //padding-bottom: 18px;

      font-size: 24px;
      line-height: 38px;
      font-weight: 700;
      letter-spacing: -0.3px;
      color: #4a4a4a;
    }
  }

  /deep/.big-switch {
    box-sizing: border-box;
    width: 230px;
    height: 52px;
    margin-left: auto;
    margin-right: auto;
    background-color: #ebedf9;
    /*border: 6px solid white;*/
    border-radius: 38px;
    box-shadow: inset 0 1px 5px 0 rgba(#9497b2, 0.1);
    position: relative;
    &-label {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      z-index: 2;
      .v-btn__content {
        font-size: 16px;
        font-weight: 700;
        letter-spacing: -0.5px;
      }
    }
    &-button {
      transition: all ease-out 0.2s;
      position: absolute;
      left: 0; top: 0;
      z-index: 1;
      width: 125px;
      height: 52px;
      border-radius: 26px;
      background-color: white;
      box-shadow: 0 2px 10px 0 rgba(#9497b2, 0.16);
    }
  }

  /*.carousel-swiper-container {*/
  /*  width: 100vw;*/
  /*  height: 100vw;*/
  /*}*/

  /*/deep/.carousel-swiper-pagination {*/
  /*  position: absolute;*/
  /*  bottom: 0;*/
  /*  z-index: 1;*/

  /*  display: flex;*/
  /*  justify-content: flex-end;*/
  /*  padding-right: 24px;*/
  /*  padding-bottom: 24px;*/

  /*  .swiper-pagination-bullet {*/
  /*    outline: none;*/
  /*    opacity: 0.8;*/
  /*  }*/
  /*  .swiper-pagination-bullet-active {*/
  /*    background: rgba(0,0,0,0.5);*/
  /*    opacity: 1;*/
  /*    border: 1px solid white;*/
  /*    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);*/
  /*  }*/
  /*}*/

  .small-feed-card {
    border-radius: 5px;
    box-shadow: 0 2px 6px 0 rgba(#cdcdcd, 0.5);
  }
  .community-more {
    box-shadow: 0 2px 6px 0 rgba(#cdcdcd, 0.5) !important;
  }
  .line-clamped-feed {
    text-align: left;
    font-size: 12px;
    line-height: 17px;
    max-height: 34px;
    letter-spacing: -0.3px;
    color: map_get($colors, charcoal);

    word-break: keep-all;
    word-wrap: break-word;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .counter {
    font-size: 10px;
    letter-spacing: -0.2px;
    color: map_get($colors, charcoal);
  }
</style>
